import React, { useEffect, useState } from "react";
import { useDataTable } from "../../../shared/hooks/DataTable";
import { InvoiceService } from "../../hoa-don/InvoiceService";
import { InvoiceDiscountList } from "../../../service/invoice/InvoiceDiscountList";
import { useToolbar } from "../../../shared/hooks/Toolbar";
import DialogDiscountInvoiceAttachment from "./components/DialogDiscountInvoiceAttachment";
import { DialogCrup } from "../../hoa-don/component/DialogCrup";
import { TenantSettingService } from "../../he-thong/tham-so-he-thong/TenantSettingService";
import { RegisterInvoiceService } from "../../../service/invoice/RegisterInvoiceService";
import { CurrencyService } from "../../danh-muc/tien-te/CurrencyService";
import { AppStorage } from "../../../service/UserStorage";
import { ServerTimeService } from "../../../service/ServerTimeService";
import moment from "moment";
import { ConfirmDialogService } from "../../../AppConfirmDialog";
import { useSign } from "../../../shared/component/Sign";
import { Dialog } from "primereact/dialog";
import { useTranslation } from "../../../shared/language";

const List = () => {
  const { t } = useTranslation();
  const header = t("common.discountInvoiceList");
  const dataKey = "id";
  const [selectInvoiceDiscounted, setSelectInvoiceDiscounted] = useState([]);
  const [
    displayDiscountInvoiceAttachment,
    setDisplayDiscountInvoiceAttachment,
  ] = useState(false);
  const [displayCrup, setDisplayCrup] = useState(null);
  const [registerInvoices, setRegisterInvoices] = useState([]);
  const [currencies, setCurrencies] = useState(null);
  const [paymentTypes, setPaymentTypes] = useState(null);
  const [registerInvoice, setRegisterInvoice] = useState(null);
  const [invoiceStatus, setInvoiceStatus] = useState(0);
  const [showIconSign, setShowIconSign] = useState(false);
  const [idInvoiceListDiscount, setIdInvoiceListDiscount] = useState(null);
  const [relatedInvoiceProperty, setRelatedInvoiceProperty] = useState(null);
  const [showIconHitoryChange, setShowIconHitoryChange] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [displayView, setDisplayView] = useState(false);
  const [pdfSrc, setPdfSrc] = useState("");
  const {
    render: renderDataTable,
    reloadLazyData,
    selectedItems,
  } = useDataTable({
    header,
    dataKey,
    columns: [
      {
        field: "invoiceListSerial",
        header: t("common.symbol"),
        width: 110,
        matchMode: "contains",
      },
      {
        field: "invoiceListNumber",
        header: t("common.invoiceListNo"),
        width: 110,
        matchMode: "contains",
      },
      {
        field: "invoiceListDate",
        header: t("common.invoiceListDate"),
        width: 120,
        dataType: "date",
        matchMode: "equals",
        filterType: "date",
      },
      {
        field: "status",
        header: t("common.status"),
        width: 100,
        matchMode: "contains",
        dataType: "custom",
        filterType: "dropdown",
        filterOptions: [
          { label: t("common.waitingSignature"), value: 0 },
          { label: t("common.signed"), value: 1 },
        ],
        customCell(rowData: any): any {
          if (!rowData.status) {
            return (
              <span className="invoice-list-discount-status invoice-list-discount-status-0">
                {t("common.waitingSignature")}
              </span>
            );
          }
          return (
            <span className="invoice-list-discount-status invoice-list-discount-status-1">
              {t("common.signed")}
            </span>
          );
        },
      },
      {
        field: "invoiceSerial",
        header: t("common.symbol"),
        width: 110,
        matchMode: "contains",
      },
      {
        field: "invoiceDate",
        header: t("report.creationDate"),
        width: 120,
        dataType: "date",
        matchMode: "equals",
        filterType: "date",
      },
      {
        field: "invoiceNumber",
        header: t("common.invoiceNumber"),
        width: 100,
        dataType: "custom",
        customCell(rowData: any): any {
          const text = rowData.invoiceNumber;
          return (
            <span
              className="underline text-primary"
              onClick={() => {
                InvoiceService.getDetail(rowData.invoiceId).then((res) => {
                  setSelectedItem(res);
                  setRegisterInvoice(
                    registerInvoices.find(
                      (item) => item.id === res.registerInvoiceId,
                    ),
                  );
                });
                if (rowData.status === 0) {
                  setShowIconSign(true);
                } else {
                  setShowIconSign(false);
                }
                setDisplayCrup(true);
              }}
            >
              {text}
            </span>
          );
        },
      },
      {
        field: "buyerLegalName",
        header: t("common.buyerLegalName"),
        width: 180,
        matchMode: "contains",
      },
      {
        field: "buyerTaxCode",
        header: t("common.buyerTaxCode"),
        width: 150,
        matchMode: "contains",
      },
      {
        field: "buyerAddress",
        header: t("common.address"),
        minWidth: 200,
        matchMode: "contains",
      },
      {
        field: "creatorName",
        header: t("common.createdBy"),
        minWidth: 200,
        matchMode: "contains",
      },
      {
        field: "creationTime",
        header: t("report.creationDate"),
        width: 110,
        dataType: "date",
        matchMode: "equals",
        filterType: "date",
      },
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      params.IsOtherInvoice = false;
      return InvoiceDiscountList.getList(params);
    },
    selectionMode: "single",
  });
  const { renderSign, sign } = useSign({ onComplete: reloadLazyData });
  let userName = AppStorage.get("UserName");

  const { renderToolbar, refreshToolbar } = useToolbar({
    dataKey,
    reloadLazyData,
    selectedItems,
    deleteItem: (id) => {
      return InvoiceDiscountList.delete(id);
    },
    otherActions: [
      {
        label: t("common.edit"),
        icon: "pi pi-fw pi-pencil",
        className: "iam-toolbar iam-toolbar-info",
        command: () => {
          setDisplayDiscountInvoiceAttachment(true);
        },
        disabled: Array.isArray(selectedItems),
      },
      {
        label: t("common.printView"),
        icon: "pi pi-fw pi-print",
        className: "iam-toolbar iam-toolbar-success",
        command: () => {
          if (Array.isArray(selectedItems)) {
            return;
          }
          if (
            selectedItems &&
            typeof selectedItems === "object" &&
            selectedItems !== null &&
            "id" in selectedItems
          ) {
            setPdfSrc(
              InvoiceDiscountList.getPdfUrl(
                (selectedItems as { id: string }).id,
              ),
            );
            setDisplayView(true);
          }
        },
        disabled: Array.isArray(selectedItems),
      },
      {
        label: t("common.commercialDiscountInvoice"),
        icon: "pi pi-fw pi-plus",
        className: "iam-toolbar",
        // command: () => setDisplayDiscountInvoiceAttachment(true),
        command: () => {
          if (Array.isArray(selectedItems)) {
            return;
          }
          if (
            selectedItems &&
            typeof selectedItems === "object" &&
            selectedItems !== null &&
            "id" in selectedItems
          ) {
            if (!(selectedItems as { invoiceId: string })?.invoiceId) {
              setRegisterInvoice(
                registerInvoices.find(
                  (item) =>
                    item.symbolCode ===
                    ((selectedItems as { invoiceSerial?: string })
                      ?.invoiceSerial ?? ""),
                ),
              );
              setDisplayCrup(true);
              if (
                selectedItems &&
                typeof selectedItems === "object" &&
                selectedItems !== null
              ) {
                setIdInvoiceListDiscount({
                  ...(selectedItems as Record<string, any>),
                  invoiceDate: new Date(),
                });
              } else {
                setIdInvoiceListDiscount({ invoiceDate: new Date() });
              }
              setShowIconSign(true);
              return;
            }
            ConfirmDialogService.showInvalid(
              t("common.invoiceListAlreadyCreated"),
            );
          }
        },
        disabled: Array.isArray(selectedItems),
      },
    ],
  });

  const handleSign = async (plugCommand) => {
    const { InvoiceIdArray } = plugCommand;

    if (!InvoiceIdArray[0].signOnly) {
      const serverTime = await ServerTimeService.getList({});
      const time = moment(serverTime.time);
      const invoiceDate = moment(InvoiceIdArray[0].invoiceDate);
      const diffInDays = time.diff(invoiceDate, "days");
      if (diffInDays >= 2) {
        ConfirmDialogService.setProps({
          className: "w-6",
          message: (
            <div>
              {t("common.discountSignTimeWarningLegalRule")} {t("common.signTimeWarningInvoiceDetails", {
                date: invoiceDate.format("DD/MM/YYYY"),
                symbol: InvoiceIdArray[0].invoiceSerial,
                number: InvoiceIdArray[0].invoiceNumber,
              })}
            </div>
          ),
          header: t("common.signTimeWarningTitle"),
          icon: "pi pi-info-circle",
          acceptClassName: "p-button-danger",
          acceptLabel: t("common.continueSign"),
          rejectLabel: t("common.reject"),
          accept: () => {
            sign({
              CommandName: "SignInvoices",
              InvoiceIdArray: [InvoiceIdArray[0].id],
            });
          },
        });
        return;
      }
    }
    sign({
      CommandName: "SignInvoices",
      InvoiceIdArray: [InvoiceIdArray[0].id],
    });
  };

  useEffect(() => {
    TenantSettingService.getList({
      key: TenantSettingService.key.BAT_LUU_LICH_SU_THAY_DOI_HOA_DON,
    })
      .then(({ items, totalCount }) => {
        if (totalCount > 0) {
          setShowIconHitoryChange(items[0].value === "C");
        }
      })
      .finally(() => {
        RegisterInvoiceService.getUsingList({
          maxResultCount: 1000,
          userName,
          Sorting: "creationTime",
          SortType: "DESCEND",
        }).then(({ items }) => {
          const _registerInvoices = [];
          items.forEach((item) => {
            item.label = `${item.symbolCode} - ${item.invoiceTypeName}`;
            _registerInvoices.push(item);
          });
          setRegisterInvoices(_registerInvoices);
        });
        CurrencyService.getList({ maxResultCount: 1000 }).then(({ items }) => {
          setCurrencies(items);
        });
        InvoiceService.getPaymentTypes().then(({ items }) => {
          const _paymentTypes = [];
          items.forEach((item) => {
            _paymentTypes.push({ value: item.name, label: item.name });
          });
          setPaymentTypes(_paymentTypes);
        });
      });
  }, []);

  useEffect(() => {
    refreshToolbar();
  }, [selectedItems]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {renderToolbar()}
      {renderDataTable()}
      {renderSign()}
      <DialogDiscountInvoiceAttachment
        display={displayDiscountInvoiceAttachment}
        setInvoices={setSelectInvoiceDiscounted}
        setDisplay={setDisplayDiscountInvoiceAttachment}
        selectedItems={selectedItems}
        reloadLazyData={reloadLazyData}
      />
      <DialogCrup
        display={displayCrup}
        setDisplay={setDisplayCrup}
        reloadLazyData={reloadLazyData}
        registerInvoices={registerInvoices}
        currencies={currencies}
        paymentTypes={paymentTypes}
        registerInvoice={registerInvoice}
        selectedItem={selectedItem}
        invoiceStatus={invoiceStatus}
        setInvoiceStatus={setInvoiceStatus}
        sign={handleSign}
        showIconSign={showIconSign}
        showSave={showIconSign}
        idInvoiceListDiscount={idInvoiceListDiscount}
        setSelectedItems={setSelectedItem}
        setDisplayDiscountInvoiceAttachment={
          setDisplayDiscountInvoiceAttachment
        }
        relatedInvoiceProperty={5}
        setRelatedInvoiceProperty={setRelatedInvoiceProperty}
        setIdInvoiceListDiscount={setIdInvoiceListDiscount}
      />
      <Dialog
        visible={displayView}
        onHide={() => setDisplayView(false)}
        style={{ width: "80%", height: "100%" }}
        header={t("common.printView")}
      >
        {pdfSrc && (
          <iframe
            src={pdfSrc}
            width="100%"
            height="100%"
            style={{ border: "none" }}
            title="pdf-preview"
          />
        )}
      </Dialog>
    </>
  );
};

export default List;
